<div #bg class="gantt_activity_bg">
    <div class="gantt_activity_row" [ngStyle]="setRowStyle()" *ngFor="let row of ganttService.groupData(tasks)">
        <div class="gantt_activity_cell" [ngStyle]="setCellStyle()" *ngFor="let cell of cells; let l = last" [ngClass]="[(isDayWeekend(cell)) ? 'weekend' : '', l ? 'last_column_cell' : '']"></div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/gantt-chart/gantt-activity/activity-background/activity-background.component.html